import { Card, Typography } from "antd";
import React from "react";
import styles from "./styles.module.scss";

const { Title, Text, Paragraph } = Typography;

interface StatCardProps {
  title: string;
  value?: React.ReactNode;
  tip?: React.ReactNode;
  description?: React.ReactNode;
  icon?: React.ReactNode;
  valueClassName?: string;
  tipClassName?: string;
  children?: React.ReactNode;
}

export const StatCard: React.FC<StatCardProps> = ({
  title,
  value,
  tip,
  description,
  icon,
  valueClassName,
  tipClassName,
  children,
}) => (
  <Card
    className={styles.statCard}
    bordered={false}
    bodyStyle={{ padding: 20 }}
  >
    <div className={styles.stastsBody}>
      <Text strong style={{ margin: 0 }}>
        {title}
      </Text>
      {icon && (
        <div className={styles.iconPlaceholder} style={{ margin: 0 }}>
          {icon}
        </div>
      )}
      {value && (
        <Title
          level={2}
          className={valueClassName || styles.statValue}
          style={{ margin: 0 }}
        >
          {value}
        </Title>
      )}
      {tip && (
        <Text className={tipClassName || styles.green} style={{ margin: 0 }}>
          {tip}
        </Text>
      )}
      {description && (
        <Paragraph
          type="secondary"
          className={styles.statDesc}
          style={{ margin: 0 }}
        >
          {description}
        </Paragraph>
      )}
      {children}
    </div>
  </Card>
);
